var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8619_240645)"
  }, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15.8667V28.875H0V0Z",
    fill: "#007AAB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8619_240645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8667 28.8749H0V17.0199C0 12.6566 0.935933 9.21218 2.80867 6.6875C4.68053 4.16367 7.89044 1.93409 12.4384 -0.000396729L15.8667 6.29825C13.0701 7.57194 11.1367 8.84058 10.0682 10.1025C8.99709 11.3653 8.40173 12.8567 8.28041 14.5785H15.8667V28.8749Z",
    fill: "#007AAB"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.704851
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8619_240645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 4,
    width: 16,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1333 4.125H28V33H12.1333V4.125Z",
    fill: "#66D4FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8619_240645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0004 33H12.1333V21.1452C12.1333 16.7819 13.0693 13.3375 14.942 10.8128C16.814 8.28903 20.024 6.05947 24.572 4.125L28.0004 10.4236C25.2038 11.6973 23.2703 12.9659 22.2018 14.2278C21.1306 15.4905 20.5353 16.982 20.4139 18.7037H28.0004V33Z",
    fill: "#66D4FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8619_240645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteMark);
export default __webpack_public_path__ + "static/media/quote-mark.84c4b0df3eef071b4180c7309df6a57c.svg";
export { ForwardRef as ReactComponent };